import React, {
    createContext,
    useContext,
    useState,
    useEffect,
} from "react";

import { authAPI, adminAPI } from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        const userData = localStorage.getItem("user_data");
        const permissionData = localStorage.getItem("permissions");

        if (token && userData) {
            setUser(JSON.parse(userData));
        }

        if (permissionData) {
            setPermissions(JSON.parse(permissionData));
        }

        setLoading(false);
    }, []);

	const login = async (username, password) => {
		const { data } = await authAPI.login({
			username,
			password,
		});

		localStorage.setItem(
			"access_token",
			data.access
		);

		localStorage.setItem(
			"refresh_token",
			data.refresh
		);

		// Load logged user
		const userRes =
			await adminAPI.currentUser();

		const userData = userRes.data;

		localStorage.setItem(
			"user_data",
			JSON.stringify(userData)
		);

		setUser(userData);

		// Load permissions
		const permissionRes = await adminAPI.permissions();

		console.log("Current User:", userData);

		console.log("Permission API Response:", permissionRes.data);

		const allPermissions = permissionRes.data.results || [];

		console.log("All Permissions:", allPermissions);

		const rolePermissions = allPermissions.filter(
			(p) => p.role_name === userData.role
		);

		console.log("Filtered Permissions:", rolePermissions);

		localStorage.setItem(
			"permissions",
			JSON.stringify(rolePermissions)
		);

		setPermissions(rolePermissions);

		localStorage.setItem(
			"permissions",
			JSON.stringify(rolePermissions)
		);

		setPermissions(rolePermissions);

		return data;
	};
    const logout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user_data");
        localStorage.removeItem("permissions");

        setUser(null);
        setPermissions([]);
    };

    const hasPermission = (
        module,
        action = "can_view"
    ) => {
        const permission = permissions.find(
            (p) => p.module === module
        );

        return permission
            ? permission[action]
            : false;
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                permissions,
                login,
                logout,
                loading,
                hasPermission,
                isAuthenticated: !!user,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);

    if (!ctx) {
        throw new Error(
            "useAuth must be used within AuthProvider"
        );
    }

    return ctx;
};